import axios from './api';
import { getQueryData, getUrl } from './utils';

const endPoint = getUrl('api') + '/api/v2/ScannedDocuments';

const getScannedDocumentByMysqlID = (id) =>
  axios.get(endPoint.concat('?mysqlId=', id), {}).then((res) => res);

const getScannedDocumentByMysqlIDAndPid = (id, pid) =>
  axios
    .get(endPoint.concat('?mysqlId=', id, '&pid=', pid), {})
    .then((res) => res);

const getScannedDocument = (id) =>
  axios
    .get(endPoint.concat('/', id), {})
    .then((res) => res)
    .catch((error) => error.response);

const getScannedDocuments = async ({ page, size, filters }) => {
  return axios
    .get(endPoint.concat('/', getQueryData(page, size, filters)), {})
    .then((res) => res)
    .catch((error) => error.response);
};

const createScannedDocument = (scannedDocument, model) =>
  axios
    .post(endPoint.concat('/', model), scannedDocument, {})
    .then((res) => res)
    .catch((error) => {
      throw error.response;
    });

const updateScannedDocument = (id, scannedDocument, model) =>
  axios
    .put(endPoint.concat('/', model, '/', id), scannedDocument, {})
    .then((res) => res)
    .catch((error) => {
      throw error.response;
    });

const deleteScannedDocument = ({ id }) =>
  axios
    .delete(endPoint.concat('/', id), {})
    .then((res) => res)
    .catch((error) => error.response);

export {
  createScannedDocument,
  deleteScannedDocument,
  getScannedDocument,
  getScannedDocumentByMysqlID,
  getScannedDocuments,
  updateScannedDocument,
  getScannedDocumentByMysqlIDAndPid,
};
